import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.20 Case 20</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_20"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 20. This is a positive case. The size and contrast have already been adjusted. Let's start at the base of the brain, at the level of the cerebellum. There is good gray-white contrast in the cerebellum. Moving into the temporal lobes bilaterally, you'll notice that you do not see distinct white matter tracts at this level on the left or the right. There is increased activity within the gray matter. Moving a little bit more superiorly, a white matter tract is partially visible in the left temporal region but not on the right-hand side. However, there remains increased activity in the gray matter, resulting in loss of gray-white contrast.
              </p>
              <p>
                As we move even more superiorly into the frontal lobes, it initially appears that there is preserved gray-white contrast, with fingerlike projections seen here and here on the left-hand side. However, it is important if you suspect atrophy to review the accompanying anatomic imaging, in this case a CT, and as you can see here, these areas of decreased tracer uptake correspond to enlarged sulci. Therefore, this is not preserved gray-white contrast and, in fact, there is loss of gray-white contrast bilaterally as well as the presence of atrophy.
              </p>
              <p>
                As we continue scrolling superiorly, distinct white matter tracts are not readily identifiable in the parietal lobe, and there is increased tracer activity in the cortical gray matter. There is loss of gray-white contrast throughout the parietal region bilaterally. Since there is loss of gray-white contrast in all regions, this is a positive case. If you called this case negative, you may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-19"
          nextLesson="/module-4/module-4-1-21"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_728486978&entry_id=1_2cjs2q4b&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_2cjs2q4b"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
